// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__Bx8l2","Logo":"Toolbar_Logo__25vWg","DesktopOnly":"Toolbar_DesktopOnly__2kg7L"};